import React, { useState } from 'react';
import { PrinterIcon } from '@/components/contextActions/icons';
import { HeaderIconButton } from '@/components/contextActions/common';
import { useErrorDialog } from '@ianesthesie-kit/redux';
import { capturePdfReportError } from '@/components/imageViewer/pdfReportError';
import { useCompleteReport } from './useCompleteReport';

export const PrintReportButton = () => {
  const { generate, isLoading: isGenerating } = useCompleteReport();
  const { showErrorDialog } = useErrorDialog();
  const [isPreparing, setIsPreparing] = useState(false);
  const [clicked, setClicked] = useState(false);

  const onPrint = async () => {
    setClicked(true);
    const medium = await generate();
    if (!medium?.path) {
      return;
    }
    setIsPreparing(true);
    try {
      const { printPdf } = await import('@/components/imageViewer/printPdf');
      await printPdf(medium.path);
    } catch (error: any) {
      capturePdfReportError(error, 'print');
      showErrorDialog(error);
    } finally {
      setIsPreparing(false);
    }
  };

  if (!isGenerating && clicked) {
    setClicked(false);
  }

  const isLoading = isGenerating && clicked;

  return (
    <HeaderIconButton
      disabled={isGenerating || isPreparing}
      loading={isLoading || isPreparing}
      icon={<PrinterIcon />}
      onClick={onPrint}
    />
  );
};
